import { compose } from 'recompose';

import MetaList from './MetaList';

const enhance = compose();

export default enhance(MetaList);
